import {cs} from "./chain-services";
import {createElement as h, Fragment} from "react";
import {Invoke} from "./invoke";
import {UseRef} from "./use-ref";
import {OnUnmounted} from "./on-unmounted";

export const Subscription = ({init, next=undefined}) => cs(
    ["removeRef", (_, next) => UseRef({next})],
    ({removeRef}) => h(Fragment, {},
        next ? next() : null,

        h(Invoke, {
            fn: () => {
                const remove = init();
                removeRef.set(remove);
            },
        }),
        OnUnmounted({
            action: () => {
                const remove = removeRef.get();
                if (remove) {
                    remove();
                }
            },
        }),
    ),
);